/**
 * Adaprox Theme — Main JavaScript
 * Replaces React interactivity with vanilla JS
 */

(function () {
  'use strict';

  /* ─── 1. Navbar Scroll Effect ─── */
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const scrollY = window.scrollY;
      if (scrollY > 20) {
        header.style.backgroundColor = 'rgba(30,58,95,0.97)';
        header.style.backdropFilter = 'blur(12px)';
        header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.15)';
      } else {
        header.style.backgroundColor = '#1E3A5F';
        header.style.backdropFilter = 'none';
        header.style.boxShadow = 'none';
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

  /* ─── 2. Mobile Menu Toggle ─── */
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  const menuIcon = document.querySelector('[data-menu-icon]');
  const closeIcon = document.querySelector('[data-close-icon]');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden');
      if (menuIcon) menuIcon.classList.toggle('hidden');
      if (closeIcon) closeIcon.classList.toggle('hidden');
    });

    // Close menu when clicking a link
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.add('hidden');
        if (menuIcon) menuIcon.classList.remove('hidden');
        if (closeIcon) closeIcon.classList.add('hidden');
      });
    });
  }

  /* ─── 3. Scroll Reveal Animation (IntersectionObserver) ─── */
  const revealElements = document.querySelectorAll('.reveal-section');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ─── 4. FAQ Accordion ─── */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var trigger = item.querySelector('.faq-trigger');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all other FAQ items
        document.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var answer = openItem.querySelector('.faq-answer');
            if (answer) answer.style.maxHeight = '0';
          }
        });

        // Toggle current
        item.classList.toggle('is-open');
        var answer = item.querySelector('.faq-answer');
        if (answer) {
          if (isOpen) {
            answer.style.maxHeight = '0';
          } else {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        }
      });
    }
  });

  /* ─── 5. Cart Notification ─── */
  window.showCartNotification = function (message) {
    var notification = document.getElementById('CartNotification');
    if (!notification) {
      notification = document.createElement('div');
      notification.id = 'CartNotification';
      notification.className = 'cart-notification';
      document.body.appendChild(notification);
    }
    notification.textContent = message || 'Added to Cart!';
    notification.classList.add('is-visible');

    setTimeout(function () {
      notification.classList.remove('is-visible');
    }, 2500);
  };

  /* ─── 6. Update Cart Count Badge ─── */
  window.updateCartCount = function (count) {
    var badge = document.getElementById('CartCount');
    if (badge) {
      badge.textContent = count;
    }
  };

})();
